var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pb-5"},[_c('div',{staticClass:"col-12"},[_c('RankingRegentes',{attrs:{"dataset":_vm.dataset}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }